$(document).ready(function() {//Sweetalert
    let pageAlert = 0;
    let errorShow = [];

    $('.auth .invalid-feedback').each(function() {
        if($(this).css('display') == 'block'){
            let getAlertMsg = $(this).find('.alert-msg').text();
            let errorMsg = '<i><sup>*</sup>' + getAlertMsg + '</i><br>';

            errorShow.push(errorMsg);
            pageAlert = 1; 
        }  
    });
    let errorHtml = errorShow.join(' ');

    if (pageAlert == 1){
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            html: errorHtml
        });

        $('.auth input').val('');
    }

    $('.forgot-password-toggle, .login-toggle').click(function()
    {
        $('#loginModal').modal('toggle');
        $('#reset-passwordModal').modal('toggle');
    });

    $('.login-pin-toggle').click(function()
    {
        $('#loginModal').modal('toggle');
        $('#reset-pinModal').modal('toggle');
    });
});